export default __webpack_public_path__ + "static/media/Gouda.b2a9c6d8.jpg";